import { API } from "./APIClient";
import qs from "qs";
import { getCurrentUserId } from "../utils/reduxUser";


class IncomeAPIClass {
    async fetchPlot(cafeId) {
        const userId = getCurrentUserId();
        const response = await API.get(`/incModule/getPlot/${cafeId}?employee_id=${userId}`);

        const result = [];
        for (const item of response.data.result) {
            result.push({
                date: item.current_date,
                value: item.revenue,
            })
        }

        return result;
    }

    async fetchInfoPlan(cafeId, countDays) {
        const userId = getCurrentUserId();
        const query = qs.stringify({
            employee_id: userId,
            cafe_id: cafeId,
            count_days: countDays,
        });

        const response = await API.get(`/incModule/infoPlan?${query}`);
        const result = {
            plan: {
                goal: response.data.plan.goal,
                current: response.data.plan.current,
            },
            motivation: {
                avgRevenue: response.data.motivation_part.avg_revenue,
                baseSalary: response.data.motivation_part.base_salary,
                alreadyEarned: response.data.motivation_part.already_earned,
            },
            currentAvgRevenue: response.data.current_avg_revenue,
            totalCurrentSalary: response.data.total_current_salary,
        }

        return result;
    }

    async fetchAverageDaily(cafeId) {
        const userId = getCurrentUserId();
        const response = await API.get(`/incModule/averageDaily/${cafeId}?employee_id=${userId}`);
    
        return response.data.average_daily;
    }
    
    async fetchAdminAverageDaily(cafeId) {
        const response = await API.get(`/admin/cafe/averageDaily/${cafeId}`);
    
        return response.data.average_daily;
    }
}

const IncomeAPI = new IncomeAPIClass();
export default IncomeAPI;
